// extracted by mini-css-extract-plugin
module.exports = {"ppdBottom":"style_ppdBottom__VvRFR","ppdWrapper":"style_ppdWrapper__J8x-o","ppdLabel":"style_ppdLabel__2tRxV","ppdValues":"style_ppdValues__lXVx6"};